import forEach from '../../../../javascripts/dom/forEach';

const galleries = document.querySelectorAll('[data-js-module="o-bento-box--gallery"]');
const quoteSliders = document.querySelectorAll('[data-js-module="o-bento-box__quote-slider"]');
const slidesSelector = '[data-js-element="o-bento-box__slides"]';
const quoteSliderSelector = '[data-js-element="o-bento-box__quote-slides"]';



function updateSlideAccessibility() {
  const slides = document.querySelectorAll('.o-bento-box__slide');

  slides.forEach(slide => {
      const isHidden = slide.getAttribute('aria-hidden') === 'true';
      const focusableElements = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

      focusableElements.forEach(element => {
          if (isHidden) {
              element.setAttribute('tabindex', '-1');
          } else {
              element.removeAttribute('tabindex');
          }
      });
  });
}
const init = async () => {
  const { tns } = await import(
    /* webpackChunkName: "tiny-slider" */ '../../../../../node_modules/tiny-slider/src/tiny-slider'
  );

  forEach(galleries, (index, element) => {
    const slidesContainer = element.querySelector(slidesSelector);
    const slider = tns({
      container: slidesContainer,
      arrowKeys: true,
      mouseDrag: true,
      mode: 'carousel',
      autoHeight: false,
      loop: true,
      nav: true,
      swipeAngle: false,
      controls: false,
      autoplay: true,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      responsive: {
        640: {
          //autoHeight: true,
        }
      },
      onInit: updateSlideAccessibility,
      onIndexChanged: updateSlideAccessibility
    });
  });

  forEach(quoteSliders, (index, element) => {
    const slidesContainer = element.querySelector(quoteSliderSelector);
    const quoteSlider = tns({
      container: slidesContainer,
      arrowKeys: true,
      mouseDrag: true,
      mode: 'carousel',
      autoHeight: false,
      loop: true,
      nav: true,
      swipeAngle: false,
      controls: false,
      autoplay: false,
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      onInit: updateSlideAccessibility,
      onIndexChanged: updateSlideAccessibility
    });
  });
};

if (galleries.length || quoteSliders.length) init();
